/*
 *weinxin_all.js include weixin.js && weixin_jssdk.js
 */
import weixin_jssdk from "weixin-js-sdk"
import $ from 'jquery'
import global from './global.js'
window.weixin = typeof weixin == 'undefined'? {} : weixin;
window.wx = typeof weixin_jssdk == "undefined" ? {}:weixin_jssdk;
import axios from 'axios'
import Vue from 'vue'
import components from '../components' //加载公共组件
Object.keys(components).forEach((key) => {
var name = key.replace(/(\w)/, (v) => v.toUpperCase()) //首字母大写
    Vue.component(`v${name}`, components[key])
})
export default{
    shareInfo:function(type,id,accountId,callback){
        var shareData={}
        let href = window.location.href;
        if(href.indexOf('groupmessage') > -1 || href.indexOf('singlemessage') > -1 || href.indexOf('timeline') > -1){
            href = href.replace(/\?from=(groupmessage|singlemessage|timeline)(\S*)#/, '#');
            window.location.href = href;
            return;
        }
        var defaultimg=global.baseImgUrl+require('../images/logo.png');
        if(type==14){//个人主页分享接口
            axios.get(global.baseHeaderUrl+"account/thrid/base/info/query",{"params":{"dataType":type,"loginAccountId":id,"accountId":accountId}})
            .then((response) => {
                shareData = {
                    title:response.respData.shareModel.shareTitle,
                    desc:response.respData.shareModel.shareMessge,
                    link:response.respData.shareModel.shareURL,
                    imgUrl:response.respData.shareModel.shareImage?response.respData.shareModel.shareImage:defaultimg,
                    success: function () {
                        //分享成功后的回调
                        axios.get(global.baseHeaderUrl+"content/unsecured/secondary/share/projectile")
                        .then((response)=>{
                            $("body").append("<div id='shareSuccessBackDiv'></div>")
                            new Vue({
                                el: '#shareSuccessBackDiv',
                                data: {
                                    showShareBack:true,
                                    showShareBackContent:response.respData,
                                },
                                methods:{
                                    closeTip(){
                                        this.showShareBack = false
                                    },
                                },
                                template:'<v-shareSuccessBack  :show="showShareBack" :content="showShareBackContent"></v-shareSuccessBack>'
                            })
                        })                        
                    }
                };
                shareInfoFn()
            })
        }
        else if(type==13){//下载页面分享接口
            axios.get(global.baseHeaderUrl+"account/thrid/sharedown",{"params":{"dataType":type,"accountId":accountId}})
            .then((response) => {
                shareData = {
                    title:response.respData.shareTitle,
                    desc:response.respData.shareMessge,
                    link:response.respData.shareURL,
                    imgUrl:response.respData.shareImage?response.respData.shareImage:defaultimg,
                    success: function () { 
                        //分享成功后的回调
                        axios.get(global.baseHeaderUrl+"content/unsecured/secondary/share/projectile")
                        .then((response)=>{
                            $("body").append("<div id='shareSuccessBackDiv'></div>")
                            new Vue({
                                el: '#shareSuccessBackDiv',
                                data: {
                                    showShareBack:true,
                                    showShareBackContent:response.respData,
                                },
                                methods:{
                                    closeTip(){
                                        this.showShareBack = false
                                    },
                                },
                                template:'<v-shareSuccessBack  :show="showShareBack" :content="showShareBackContent"></v-shareSuccessBack>'
                            })
                        }) 
                    }
                };
                shareInfoFn()
            })
        }
        else{//其他页面分享接口
            axios.get(global.baseHeaderUrl+"content/unsecured/secondary/share/query/details",{"params":{"dataType":type,"contentId":id,"accountId":accountId}})
            .then((response) => {
                shareData = {
                    title:response.respData.shareTitle,
                    desc:response.respData.shareMessge,
                    link:response.respData.shareURL,
                    imgUrl:response.respData.shareImage?response.respData.shareImage:defaultimg,
                    success: function () { 
                        //分享成功后的回调
                        axios.get(global.baseHeaderUrl+"content/unsecured/secondary/share/projectile")
                        .then((response)=>{
                            $("body").append("<div id='shareSuccessBackDiv'></div>")
                            new Vue({
                                el: '#shareSuccessBackDiv',
                                data: {
                                    showShareBack:true,
                                    showShareBackContent:response.respData,
                                },
                                methods:{
                                    closeTip(){
                                        this.showShareBack = false
                                    },
                                },
                                template:'<v-shareSuccessBack  :show="showShareBack" :content="showShareBackContent"></v-shareSuccessBack>'
                            })
                        }) 
                    }
                };
                shareInfoFn()
            })
        }
    function shareInfoFn(){
        axios.get(global.baseHeaderUrl+"/content/unsecured/weixinShare/getSign?url="+window.location.href.split("#")[0])
            .then((res) => {
                wx.config({
                    //开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    debug:false,
                    //必填，公众号的唯一标识
                    appId:res.respData.appId,

                    //必填，生成签名的时间戳
                    timestamp:res.respData.signMap.timestamp,

                    //必填，生成签名的随机串
                    nonceStr:res.respData.signMap.nonceStr,

                    //必填，签名，见附录1
                    signature:res.respData.signMap.signature,

                    //必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    jsApiList:['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
                });
                wx.ready(function() {
                    //config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                    //判断当前版本是否支持指定 JS 接口，支持批量判断

    
                    wx.checkJsApi({
                        jsApiList: [
                        'onMenuShareAppMessage',  //分享给朋友
                        'onMenuShareTimeline',	//分享到朋友圈
                        'onMenuShareQQ',			//分享到QQ
                        'onMenuShareWeibo',		//分享到腾讯微博
                        'onMenuShareQZone'		//分享到QQ空间
                        ],
                        success: function (res) {
                        
                        }
                    });
                    //分享给朋友
                    wx.onMenuShareAppMessage(shareData);
                        
                    //分享到朋友圈
                    wx.onMenuShareTimeline(shareData);
                    
                    //分享到QQ
                    wx.onMenuShareQQ(shareData);
                    
                    //分享到腾讯微博
                    wx.onMenuShareWeibo(shareData);
                    
                    //分享到QQ空间
                    wx.onMenuShareQZone(shareData);
                });

                //步骤五：通过error接口处理失败验证
                wx.error(function(res) {
                    //config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    //alert(JSON.stringify(res));
                });
            });
       }
    },
    shareTitle:function(type,contentId,callback){
        axios.get(global.baseHeaderUrl+"content/unsecured/share/page/get/rollinginfo",{"params":{"contentType":type,"contentId":contentId}})
        .then((response) => {
            callback(response.respData)
        })
    }
}



// WEBPACK FOOTER //
// ./src/js/weixinall.js